import { render } from "./TourGuides.vue?vue&type=template&id=32f3f9ff"
import script from "./TourGuides.vue?vue&type=script&lang=js"
export * from "./TourGuides.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__